export const benefits_CreateContent = [
	{
		icon: '🔹',
		title: 'benefitsData.title1',
		subtitle: 'benefitsData.subtitle1',
	},
	{
		icon: '🔹',
		title: 'benefitsData.title2',
		subtitle: 'benefitsData.subtitle2',
	},
	{
		icon: '🔹',
		title: 'benefitsData.title3',
		subtitle: 'benefitsData.subtitle3',
	},
	{
		icon: '🔹',
		title: 'benefitsData.title4',
		subtitle: 'benefitsData.subtitle4',
	},
	{
		icon: '🔹',
		title: 'benefitsData.title5',
		subtitle: 'benefitsData.subtitle5',
	},
];
